var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19984 0H18.8985L27.9659 9.45128V27.8341C27.9659 30.1369 26.1029 32 23.808 32H8.19984C5.897 32 4.03394 30.1369 4.03394 27.8341V4.1659C4.0339 1.86306 5.89696 0 8.19984 0Z",
    fill: "#CC6F2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8904 0V9.37931H27.9658L18.8904 0Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1434_258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.86328 22V17.8H11.6813C12.0573 17.8 12.3813 17.862 12.6533 17.986C12.9253 18.106 13.1353 18.28 13.2833 18.508C13.4313 18.736 13.5053 19.008 13.5053 19.324C13.5053 19.636 13.4313 19.906 13.2833 20.134C13.1353 20.362 12.9253 20.538 12.6533 20.662C12.3813 20.782 12.0573 20.842 11.6813 20.842H10.4033L10.8353 20.404V22H9.86328ZM10.8353 20.512L10.4033 20.05H11.6273C11.9273 20.05 12.1513 19.986 12.2993 19.858C12.4473 19.73 12.5213 19.552 12.5213 19.324C12.5213 19.092 12.4473 18.912 12.2993 18.784C12.1513 18.656 11.9273 18.592 11.6273 18.592H10.4033L10.8353 18.13V20.512ZM14.1992 22V17.8H16.0172C16.3932 17.8 16.7172 17.862 16.9892 17.986C17.2612 18.106 17.4712 18.28 17.6192 18.508C17.7672 18.736 17.8412 19.008 17.8412 19.324C17.8412 19.636 17.7672 19.906 17.6192 20.134C17.4712 20.362 17.2612 20.538 16.9892 20.662C16.7172 20.782 16.3932 20.842 16.0172 20.842H14.7392L15.1712 20.404V22H14.1992ZM15.1712 20.512L14.7392 20.05H15.9632C16.2632 20.05 16.4872 19.986 16.6352 19.858C16.7832 19.73 16.8572 19.552 16.8572 19.324C16.8572 19.092 16.7832 18.912 16.6352 18.784C16.4872 18.656 16.2632 18.592 15.9632 18.592H14.7392L15.1712 18.13V20.512ZM19.2938 22V18.592H17.9498V17.8H21.6098V18.592H20.2658V22H19.2938Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1434_258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 5,
    fill: "white",
    transform: "translate(9 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.18f90a810f153fe1b43ecb294e374c01.svg";
export { ForwardRef as ReactComponent };